import {
  PRODUCT_STATUS_FILTER_VALUES,
  RECOMMENDED_PRODUCTS_FILTER_VALUES,
  SIZED_QUANTITY_FILTER_VALUES,
  EXCLUDED_PRODUCT_VALUES
} from '../constants/uiConstants'
import {
  WISH_LIST_PRODUCT_FILTER_VALUES,
  PRODUCT_PRESENTATION_FILTER_TAB_IDS
} from '@modules/showroom/productCollection/constants/uiConstants'
import { PRODUCT_MISC_FIELD_IDS } from '@modules/showroom/productCollection/constants/product-misc-field-ids'
import { CORE_PRODUCT_FILTER_VALUES } from '@modules/order/constants/uiConstants'

const returnTrueFalse = (values, trueValue, falseValue) => {
  const trueValIndex = (values || []).indexOf(trueValue)
  if (trueValIndex !== -1) {
    const falseValIndex = (values || []).indexOf(falseValue)
    if (falseValIndex !== -1) {
      return undefined
    }
    return true
  }
  if ((values || []).indexOf(falseValue) !== -1) {
    return false
  }
}

const filterTransformers = {
  [PRODUCT_MISC_FIELD_IDS.ACTIVE_PRODUCTS]: values =>
    returnTrueFalse(
      values,
      PRODUCT_STATUS_FILTER_VALUES.ACTIVE_PRODUCTS,
      PRODUCT_STATUS_FILTER_VALUES.INACTIVE_PRODUCTS
    ),
  [PRODUCT_MISC_FIELD_IDS.RECOMMENDED_PRODUCTS]: values =>
    returnTrueFalse(
      values,
      RECOMMENDED_PRODUCTS_FILTER_VALUES.RECOMMENDED_PRODUCTS,
      RECOMMENDED_PRODUCTS_FILTER_VALUES.NON_RECOMMENDED_PRODUCTS
    ),
  [PRODUCT_MISC_FIELD_IDS.SIZED_QTY]: values =>
    returnTrueFalse(
      values,
      SIZED_QUANTITY_FILTER_VALUES.WITH_QUANTITY,
      SIZED_QUANTITY_FILTER_VALUES.WITHOUT_QUANTITY
    ),
  [PRODUCT_PRESENTATION_FILTER_TAB_IDS.WISHLIST_PRODUCT]: values =>
    returnTrueFalse(
      values,
      WISH_LIST_PRODUCT_FILTER_VALUES.SELECTED,
      WISH_LIST_PRODUCT_FILTER_VALUES.NOT_SELECTED
    ),
  [PRODUCT_MISC_FIELD_IDS.CORE_PRODUCTS]: values =>
    returnTrueFalse(
      values,
      CORE_PRODUCT_FILTER_VALUES.CORE_PRODUCTS,
      CORE_PRODUCT_FILTER_VALUES.NON_CORE_PRODUCTS
    ),
  [PRODUCT_MISC_FIELD_IDS.EXCLUDED_PRODUCTS]: values =>
    returnTrueFalse(values, EXCLUDED_PRODUCT_VALUES.EXCLUDED_PRODUCT, null)
}

export const filterValueMapper = (key, values) => filterTransformers[key]?.(values)
